import { z, ZodSchema } from "zod";
import { initFirebase } from "@shared/services/api/firebase";
import { useMutation } from "@tanstack/react-query";
import { USER_SET, usePlatformDispatch } from "@platform//PlatformContext";
import { formatFirebaseError } from "@shared/services/api/formatFirebaseError";
import { updateUserEmail } from "../utils/updateUserEmail";

type Args = {
  onSuccess?: (data: any) => void;
  schema: ZodSchema;
  currentEmail: string;
};

export function useAccountMutation({ onSuccess, schema, currentEmail }: Args) {
  const dispatch = usePlatformDispatch();

  return useMutation({
    mutationFn: async (data: z.infer<typeof schema>) => {
      return updateUserEmail({
        currentEmail,
        newEmail: data.email,
        password: data.password,
      });
    },
    onError: (error: Error) => {
      throw new Error(formatFirebaseError(error.message));
    },
    onSuccess: async (data, variables) => {
      // dispatch update user data
      dispatch({
        type: USER_SET,
        payload: {
          user: {
            ...data.user_data,
            email: variables.email,
            authToken: data.authToken,
          },
        },
      });

      const auth = await initFirebase();

      const user = auth.currentUser;

      // Force refresh from Firebase so new email is stored in localStorage
      await user?.reload();

      // submit callback
      onSuccess?.(data);

      window.location.reload();
    },
  });
}

export default useAccountMutation;
